<template>
  <div>
    <v-btn icon small @click="onClick">
      <v-icon :size="size === 'large' ? '20' : '16'" color="#828282"
        >fal fa-circle-exclamation</v-icon
      >
    </v-btn>
    <span
      :class="[size === 'large' ? 'text-md-subtitle-2 body-2' : 'caption']"
      class="grey--text"
    >
      {{ count }} <translate>Report</translate> </span
    >
  </div>
</template>
<script>
export default {
  name: "ButtonReport",
  props: ["size", "count"],
  data: () => ({}),
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    async onClick() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      } else {
        this.$emit("click");
      }
    },
  },
};
</script>